/**
 * Devuelve un array de números correlativos. Ambos incluídos.
 * @param start Integer
 * @param end Integer
 * @return {[]}
 */
const range = (start, end) => Array.from({length: (end - start + 1)}, (v, k) => k + start);

export default range;